import {
  evaluationsHref,
  WORKSPACE_SETTINGS_DESTINATION,
} from 'features/navbar/configSettings/workspaceSettingsLink'

type OpenDestinationTab = (options: {
  destinationKey: string
  label: string
  href: string
  reuseMode?: 'focus-preserving-state' | 'focus-and-navigate'
}) => void

type NavigateToEvaluations = (options: {
  to: '/evaluations'
}) => Promise<void> | void

/** Open Evaluations landing page as its own workspace tab. */
export function openEvaluationsTab({
  navigate,
  openDestinationTab,
  organizationId,
  siteId,
}: {
  navigate: NavigateToEvaluations
  openDestinationTab: OpenDestinationTab | undefined
  organizationId?: string
  siteId?: string
}): void {
  if (openDestinationTab) {
    openDestinationTab({
      destinationKey: WORKSPACE_SETTINGS_DESTINATION.evaluations,
      label: WORKSPACE_SETTINGS_DESTINATION.evaluations,
      href: evaluationsHref({ organizationId, siteId }),
      reuseMode: 'focus-and-navigate',
    })
    return
  }

  void navigate({ to: '/evaluations' })
}
